import MyBrand from 'Components/MyBrand';
import * as React from 'react';
import { NavDropdown } from 'react-bootstrap';
import { DropdownSubmenu, NavDropdownMenu } from 'react-bootstrap-submenu';
import "react-bootstrap-submenu/dist/index.css";
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { useNavigate } from 'react-router-dom';
const TOURNEY_SEASON = 9;

const SERVERS = {
	AS: "Asia",
	EU: "Global",
	JP: "Japan",
	KR: "Korea",
	NA: "North America",
	TWHKMC: "Taiwan / Hong Kong / Macau",
}

// TODO: Add a scroll to top footer?
export function MidokuniNavBar() {
	const links = [
		['/StudentInsights', 'Insights'],
		['/About', 'About'],
		['/Resources', 'Resources'],
		['/Summary/Roadmap', 'Roadmap'],
		['/Tool/Roster', 'Roster'],
	]
	const navigate = useNavigate();
	function RaidServers() {
		return (
			<>
				{Object.keys(SERVERS).map(key => <NavDropdown.Item key={`/Raid/${key}`} href={`/Raid/${key}`}>
					<Nav.Link key={`/Raid/${key}`} href={`/Raid/${key}`}>{SERVERS[key]}</Nav.Link>
				  </NavDropdown.Item>)}
			</>
		)
	}

	function GrandRaidServers() {
		const raids = {
			...SERVERS,
			TOURNAMENT: "Tournament",
		}
		
		return (
			<>
				{Object.keys(raids).map(key => <NavDropdown.Item key={`/GrandRaid/${key}`} href={`/GrandRaid/${key}`}>
					<Nav.Link key={`/GrandRaid/${key}`} href={`/GrandRaid/${key}`}>{raids[key]}</Nav.Link>
				  </NavDropdown.Item>)}
			</>
		)
	}
	function TowerServers() {
		
		return (
			<>
				{Object.keys(SERVERS).map(key => <NavDropdown.Item key={`/Tower/${key}`}  href={`/Tower/${key}`}>
					<Nav.Link key={`/Tower/${key}`} href={`/Tower/${key}`}>{SERVERS[key]}</Nav.Link>
				</NavDropdown.Item>)}
			</>
		)
	}
	function JfdServers() {
		const type="JFD";
		const raids = {
			AS: "Asia",
			// EU: "Global",
			JP: "Japan",
			// KR: "Korea",
			// NA: "North America",
			// TWHKMC: "Taiwan / Hong Kong / Macau",
		}
		
		// {Object.keys(raids).map(key => <NavDropdown.Item>
		// 	<Nav.Link onClick={()=>navigate(`/Raid/${key}`)} key={`/Raid/${key}`}>{raids[key]}</Nav.Link>
		//   </NavDropdown.Item>)}
		return (
			<>
				{Object.keys(raids).map(key => <NavDropdown.Item href={`/${type}/${key}`}>
					<Nav.Link key={`/${type}/${key}`} href={`/${type}/${key}`}>{raids[key]}</Nav.Link>
				  </NavDropdown.Item>)}
			</>
		)
	}
	const pvpKey = localStorage.getItem("midokuni.pvp.private.key");
	return (
	<Navbar 
	collapseOnSelect 
	expand="lg" 
	// style={{ height: 71 }} 
	sticky="top" 
	className="bg-body-tertiary my-nav"
	data-bs-theme="dark">
		<Navbar.Brand href="/" style={{marginLeft: 10}}>
			<MyBrand />
		</Navbar.Brand>
		<Navbar.Toggle aria-controls="responsive-navbar-nav" />
		<Navbar.Collapse style={{verticalAlign: "center"}} id="responsive-navbar-nav">
			<Nav className="me-auto" style={{ marginLeft: 10 }}>
				{/* <Nav.Link href="/StudentInsights" disabled={window.location.pathname.startsWith("/StudentInsights")}>
						<sub>Student<br></br></sub>
						<small>Insights</small>
				</Nav.Link> */}
				{links.map(d=>(
					<Nav.Link key={d[0]} href={d[0]} disabled={window.location.pathname.startsWith(d[0])}>
						{d[1]}
					</Nav.Link>))
				}
				<NavDropdownMenu title="History">
						<DropdownSubmenu href="#Total_Assault" title="Total Assault">
							<NavDropdown.ItemText>Raid</NavDropdown.ItemText>
							<RaidServers />				  
						</DropdownSubmenu>
						<DropdownSubmenu href="#Grand_Assault" title="Grand Assault">
							<NavDropdown.ItemText>Tricolor Raid</NavDropdown.ItemText>
							<GrandRaidServers />
						</DropdownSubmenu>
					<NavDropdown.Divider/>
						<DropdownSubmenu href="#Joint_Firing_Drill" title="Joint Firing Drill">
							<NavDropdown.ItemText>Joint Exercise</NavDropdown.ItemText>
							<JfdServers />
						</DropdownSubmenu>
						<DropdownSubmenu href="#Final_Restriction_Release" title="Final Restriction Release">
							<NavDropdown.ItemText>Tower</NavDropdown.ItemText>
							<TowerServers />
						</DropdownSubmenu>
					<NavDropdown.Divider/>
						<DropdownSubmenu href="#Tactical_Challenge" title="Tactical Challenge">
							<NavDropdown.ItemText>PVP</NavDropdown.ItemText>
							<NavDropdown.ItemText>Unmaintained</NavDropdown.ItemText>
							<NavDropdown.Item href="/PVP">
							
								<Nav.Link key="/PVP" href="/PVP">EPIC</Nav.Link>
							</NavDropdown.Item>
							{ pvpKey ? <NavDropdown.Item href={`/PVP/${pvpKey}`}>
								<Nav.Link key={`/PVP/${pvpKey}`} href={`/PVP/${pvpKey}`}>Private</Nav.Link>
							</NavDropdown.Item> : null}
						</DropdownSubmenu>
				</NavDropdownMenu>

				<NavDropdownMenu title="Summary">
					<NavDropdown.Item href="/Summary/Banner">
						<Nav.Link key="/Summary/Banner" href="/Summary/Banner">Banner</Nav.Link>
					</NavDropdown.Item>
					<NavDropdown.Item href="/Summary/Farmable">
						<Nav.Link key="/Summary/Farmable" href="/Summary/Farmable">Farmable</Nav.Link>
					</NavDropdown.Item>
					<NavDropdown.Item href="/Summary/Hard">
						<Nav.Link key="/Summary/Hard" href="/Summary/Hard">Hard Quest</Nav.Link>
					</NavDropdown.Item>
					<NavDropdown.Item href="/Summary/Roadmap">
						<Nav.Link key="/Summary/Roadmap" href="/Summary/Roadmap">Roadmap</Nav.Link>
					</NavDropdown.Item>
				</NavDropdownMenu>

				<NavDropdownMenu title="Tools">
					<NavDropdown.Item href="/Tool/PVP">
						<Nav.Link key="/Tool/PVP" href="/Tool/PVP">PVP Analyzer</Nav.Link>
					</NavDropdown.Item>
					<NavDropdown.Item href="/Tool/StudentEXP">
						<Nav.Link key="/Tool/StudentEXP" href="/Tool/StudentEXP">SEX</Nav.Link>
					</NavDropdown.Item>
					<NavDropdown.Item href="/Tool/Roster">
						<Nav.Link key="/Tool/Roster" href="/Tool/Roster">Student Sharing</Nav.Link>
					</NavDropdown.Item>
					<NavDropdown.Item href="/Tool/TeamBuilder">
						<Nav.Link key="/Tool/TeamBuilder" href="/Tool/TeamBuilder">Team Builder (WIP)</Nav.Link>
					</NavDropdown.Item>
					<NavDropdown.Item href="/Tool/GiftChecker">
						<Nav.Link key="/Tool/GiftChecker" href="/Tool/GiftChecker">Gift Checker</Nav.Link>
					</NavDropdown.Item>
					<NavDropdown.Item href="/Tool/Spark">
						<Nav.Link key="/Tool/Spark" href="/Tool/Spark">Spark Tracker</Nav.Link>
					</NavDropdown.Item>
					<NavDropdown.Item href="/Tool/SparkAnalytics">
						<Nav.Link key="/Tool/SparkAnalytics" href="/Tool/SparkAnalytics">Spark Analytics</Nav.Link>
					</NavDropdown.Item>
					<NavDropdown.Divider/>
						<DropdownSubmenu href="#Grand_Tournament" title="Grand Tournament">
							<NavDropdown.ItemText>Grand Tournament</NavDropdown.ItemText>
							<NavDropdown.Item href={`/Tool/GrandTournament/${TOURNEY_SEASON}`}>
								<Nav.Link key={`/Tool/GrandTournament/${TOURNEY_SEASON}`} href={`/Tool/GrandTournament/${TOURNEY_SEASON}`}>Referee</Nav.Link>
							</NavDropdown.Item>	
							<NavDropdown.Item href={`/Tool/GrandTournamentList/${TOURNEY_SEASON}`}>
								<Nav.Link key={`/Tool/GrandTournamentList/${TOURNEY_SEASON}`} href={`/Tool/GrandTournamentList/${TOURNEY_SEASON}`}>Summary</Nav.Link>
							</NavDropdown.Item>
						</DropdownSubmenu>
						<DropdownSubmenu href="#Board_Runner" title="Board Runner">
							<NavDropdown.ItemText>Board Runner Simulators</NavDropdown.ItemText>
							<NavDropdown.ItemText>(Currently Barebones)</NavDropdown.ItemText>
							<NavDropdown.Item href="/Tool/Board/Yuuka">
								<Nav.Link key="/Tool/Board/Yuuka" href="/Tool/Board/Yuuka">Yuuka</Nav.Link>
							</NavDropdown.Item>
							<NavDropdown.Item href="/Tool/Board/Saki">
								<Nav.Link key="/Tool/Board/Saki" href="/Tool/Board/Saki">Saki</Nav.Link>
							</NavDropdown.Item>
							<NavDropdown.Item disabled href="/Tool/Board/Custom">
								<Nav.Link disabled key="/Tool/Board/Custom" href="/Tool/Board/Custom">Custom (Coming Soon)</Nav.Link>
							</NavDropdown.Item>
						</DropdownSubmenu>

				</NavDropdownMenu>

				<NavDropdownMenu title="Fun">
					<NavDropdown.Item href="/Fun/Kivodle">
						<Nav.Link key="/Fun/Kivodle" href="/Fun/Kivodle">Kivodle</Nav.Link>
					</NavDropdown.Item>
					<NavDropdown.Item href="/Fun/BaSort">
						<Nav.Link key="/Fun/BaSort" href="/Fun/BaSort">BA Sort</Nav.Link>
					</NavDropdown.Item>
					<NavDropdown.Item href="/Fun/Crossword">
						<Nav.Link key="/Fun/Crossword" href="/Fun/Crossword">Crossword Puzzle</Nav.Link>
					</NavDropdown.Item>
					<NavDropdown.Item href="https://www.youtube.com/watch?v=TI83PTcY4Mk">
						<Nav.Link key="Bad-Student" href="https://www.youtube.com/watch?v=TI83PTcY4Mk">Bad Student</Nav.Link>
					</NavDropdown.Item>
					<NavDropdown.Item href="/ToSchool~EN" disabled>
						<Nav.Link disabled key="/ToSchool~EN" href="/ToSchool~EN">ToSchool ~ ENGLISH</Nav.Link>
					</NavDropdown.Item>
				</NavDropdownMenu>
			</Nav>
		</Navbar.Collapse>
	</Navbar>);
}
